export enum DataType {
  Accumulate = 'accumulate',
  Exception = 'exception',
  Duration = 'duration',
}
